<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import { auth as $store } from '@/store/AuthModule'
import RecyclingFolderService from '@/services/recyclingModule/RecyclingFolderService'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'AddAttachmentPCModal',
  components: { DialogCloseButton, PopupModal },
  data() {
    return {
      loading: false,

      currentRecyclingFolder: null,

      newAttachmentList: [],

      error: null,

      limitAttachmentAtTwoFiles: (files) => {
        return (
          !files ||
          files.length <= 2 - this.currentRecyclingFolder.attachmentList.length ||
          this.$t('ERROR_INPUT.MAX_FILES', {
            max: 2 - this.currentRecyclingFolder.attachmentList.length
          })
        )
      },

      validateButton: undefined,

      resolvePromise: undefined,
      rejectPromise: undefined
    }
  },
  methods: {
    async show(opts = {}) {
      this.currentRecyclingFolder = opts.currentRecyclingFolder

      this.loading = true
      try {
        this.$refs.popup.open()

        return new Promise((resolve, reject) => {
          this.resolvePromise = resolve
          this.rejectPromise = reject
        })
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async _reject() {
      this.error = {}
      this.newAttachmentList = []
      this.resolvePromise({
        confirmed: false
      })
      this.$refs.popup.close()
    },
    async sendNewAttachment() {
      this.loading = true
      const recyclingFolderBoomerangId = this.currentRecyclingFolder.boomerangId
      try {
        const data = {
          recyclingFolderBoomerangId: recyclingFolderBoomerangId,
          requesterCollaboratorId: $store.state.currentCollaborator.technical_id
        }
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        if (this.newAttachmentList && this.newAttachmentList.length > 0) {
          this.newAttachmentList.forEach((file, index) => {
            formData.append(`new_attachment_list_${index}`, file)
          })
        }
        await RecyclingFolderService.addNewAttachmentToRecyclingFolder(formData)
        displayToast(
          this.$t(
            'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ATTACHMENT_PC_MODAL.SENT_SUCCESS'
          ),
          'success'
        )
        this.newAttachmentList = []
        this.$emit('refresh-recycling-folder')
        this.resolvePromise({
          confirmed: true
        })
        this.$refs.popup.close()
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <popup-modal ref="popup">
    <v-form ref="form" @submit.prevent="sendNewAttachment">
      <DialogCloseButton :close-method="_reject" />

      <div>
        <div class="content-title">
          {{ $t('RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ATTACHMENT_PC_MODAL.TITLE') }}
        </div>

        <div class="mt-8 mb-4 content detail-content">
          <p class="sub-title">
            {{
              $t(
                'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ATTACHMENT_PC_MODAL.MESSAGE_1'
              )
            }}
          </p>
        </div>

        <v-file-input
          class="mt-3 mb-4"
          :label="
            $t(
              'RECYCLING_MODULE.STEP_PRODUCT_CHECKING.RECONDITIONER.ADD_ATTACHMENT.INPUT_LABEL_BY_PC'
            )
          "
          accept=".jpg, .png"
          append-inner-icon="mdi-download"
          multiple
          chips
          counter
          show-size
          v-model="newAttachmentList"
          :rules="[limitAttachmentAtTwoFiles]"
          :disabled="this.currentRecyclingFolder.attachmentList.length >= 2"
        />

        <!--Send button-->
        <div class="d-flex justify-center">
          <v-btn
            :disabled="
              newAttachmentList.length === 0 ||
              newAttachmentList.length > 2 - this.currentRecyclingFolder.attachmentList.length ||
              loading
            "
            :loading="loading"
            class="boom-button dialog-button"
            variant="outlined"
            type="submit"
          >
            {{ $t('COMMON.BUTTON.SAVE') }}
          </v-btn>
        </div>
      </div>
    </v-form>
  </popup-modal>
</template>

<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.detail-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
